import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "t-14m text-black h-full px-4 py-4 lg:px-6 space-y-8 lg:py-6"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Back to All Documents")
const _hoisted_3 = { class: "mdlg:h-[calc(100vh-360px)] grid grid-cols-1 mdlg:grid-cols-[1fr,330px] gap-6 lg:h-[calc(100%-60px)]" }
const _hoisted_4 = { class: "bg-wrh-blue-background h-full rounded-lg min-h-56" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "t-18m mdlg:t-22m" }
const _hoisted_7 = { class: "text-wrh-blue-light mt-3 mdlg:mt-5 font-normal" }
const _hoisted_8 = {
  key: 0,
  class: "text-wrh-blue-light font-normal"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Download PDf ")

import {
  toRefs, ref, watch,
} from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import Download from '@/components/icons/DownloadIcon.vue';
import BackArrow from '@/components/icons/BackArrowIcon.vue';
import { Document } from '@/models';
import DocumentViewSkeleton from '@/components/skeleton/DocumentViewSkeleton.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    showViewSkeleton: { type: Boolean, required: true },
    document: { type: null, required: true },
    documentPDF: { type: String, required: true }
  },
  emits: ['back', 'download'],
  setup(__props: any, { emit }) {

const props = __props as {
  showViewSkeleton: boolean,
  document: Document,
  documentPDF: string,
}
const store = useStore();



const { showViewSkeleton, document, documentPDF } = toRefs(props);

const emitBack = () => {
  emit('back');
};

const emitDownload = () => {
  if (!store.getters.isLoginAsAdmin) {
    emit('download');
  }
};

return (_ctx: any,_cache: any) => {
  return (_unref(showViewSkeleton))
    ? (_openBlock(), _createBlock(DocumentViewSkeleton, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "text-wrh-blue-light flex items-center t-18m md:t-22m cursor-pointer",
          onClick: emitBack
        }, [
          _createVNode(BackArrow, { class: "w-6 md:w-8 mr-1" }),
          _hoisted_2
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("article", _hoisted_4, [
            _createElementVNode("iframe", {
              src: _unref(documentPDF),
              title: "showPDF",
              class: "w-full h-full"
            }, "\n        ", 8, _hoisted_5)
          ]),
          _createElementVNode("aside", null, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(document).title), 1),
            _createElementVNode("h3", _hoisted_7, " Uploaded by " + _toDisplayString(_unref(document).uploadedBy), 1),
            (_unref(document).uploadedAt)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_8, " Uploaded on " + _toDisplayString(_unref(format)(new Date(_unref(document).uploadedAt), 'MM/dd/yyyy')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "text-white t-14m mt-3 mdlg:mt-5 bg-wrh-green-medium flex items-center justify-center px-8 py-2 rounded uppercase hover:bg-wrh-green-dark focus:outline-none transition-colors duration-300 ease-in-out",
              onClick: emitDownload
            }, [
              _createVNode(Download, { class: "w-4 mdlg:w-5 mr-[10px]" }),
              _hoisted_9
            ])
          ])
        ])
      ]))
}
}

})